// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__20p7U","footer":"ModalCreateQualiphyProcedure_footer__jh_T2","additionData":"ModalCreateQualiphyProcedure_additionData__1xFIu"};